<template>
  <div class="spcore-patient pl-4">
    <loader v-if="isFiltering.filterList" />
    <SPCoreMenu class="mb-2" />
    Patient List > Patient Benefit Profile
    <div class="hvh-flex wrap mt-3">
      <div class="benefit shadow col-12 col-sm-6 mr-4 mb-4">
        <h3 class="no-wrap">Benefit Profile</h3>
        <img class="mt-5" :src="$loadImage(patientActiveImage)" />

        <div class="no-wrap mt-5"><b>Completed Date:</b> {{ getFormattedDate(patientviewData.bV_End) }}</div>
        <div class="no-wrap"><b>Product:</b> {{ patientviewData.product }}</div>

        <div class="no-wrap mt-5"><b>Payer Name:</b>{{ patientviewData.payerName }}</div>
        <div class="no-wrap"><b>Payer Type:</b> {{ patientviewData.payerType }}</div>

        <div class="no-wrap mt-5"><b>Plan Name:</b></div>
        <div class="no-wrap"><b>Plan Type:</b></div>

        <div class="no-wrap mt-5"><b>Outcome:</b>{{ patientviewData.outcome }}</div>
        <div class="no-wrap"><b>Outcome Reason:</b>{{ patientviewData.outcomeReason }}</div>

        <div class="hvh-flex no-wrap mt-5">
          <div class="mr-5">
            <b>{{ patientviewData.firstFill }}</b> First Fills
          </div>
          <div>
            <b>{{ patientviewData.lastFill }}</b> Last Fills
          </div>
        </div>
        <div class="top-border my-2" />
        <div class="no-wrap">
          <b>{{ patientviewData.refillLeft }}</b> Refills Remaining
        </div>
      </div>
      <div class="col-12 col-sm-5 mb-4 p-0">
        <div class="shadow">
          <div class="hvh-flex space-between p-3">
            <h3 class="no-wrap">Risk Status</h3>
            <div class="hvh-flex risk px-3" :style="colorStyle">
              <div>{{ patientviewData.risk }} Risk</div>
            </div>
          </div>
          <div class="risk-status p-3">
            <div><span class="yellow-dot" :style="colorStyle" /> Aging Case</div>
            <h3 class="mt-4">{{ patientviewData.nextBestAction }}</h3>
            <div class="splitter mt-3 pt-3">
              <HvhInputCheckbox><span class="ml-2">Offer Bridge</span></HvhInputCheckbox>
              <p class="mt-3 mb-0">Contact call center</p>
              1(800)123-4567
            </div>
          </div>
        </div>
      </div>
      <div class="shadow col-12 col-sm-6 mr-4 mb-4">
        <h3 class="no-wrap">Deductible and Out of Pocket</h3>
        <div>
          <p class="font-14px mt-4 mb-0">Individual Deductible</p>
          <v-progress-linear class="mt-1" :value="deductPercent" color="#2F6B7E" height="20">
            <strong>{{ Math.ceil(deductPercent) }}%</strong>
          </v-progress-linear>
          <div class="font-10px hvh-flex space-between mt-1">
            <div class="mr-3">
              <b>Individual Deductible Amount Met</b>
              <p class="font-10px"></p>
            </div>
            <div class="text-right">
              <b>Individual Deductible</b>
              <p class="font-10px"></p>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <p class="font-14px mt-4 mb-0">Individual Out of Pocket</p>
          <v-progress-linear class="mt-1" :value="outPercent" color="#2F6B7E" height="20">
            <strong>{{ Math.ceil(outPercent) }}%</strong>
          </v-progress-linear>
          <div class="font-10px hvh-flex space-between mt-1">
            <div class="mr-3">
              <b>Individual Out of Pocket Amount Met</b>
              <p class="font-10px"></p>
            </div>
            <div class="text-right">
              <b>Individual Out of Pocket</b>
              <p class="font-10px"></p>
            </div>
          </div>
        </div>
      </div>

      <div class="hvh-flex column space-between col-12 col-sm-5 mb-4 p-0">
        <div class="shadow p-2">
          <h3 class="no-wrap">Copay and Coinsurance</h3>
          <div class="font-14px mt-4">
            <div><b>Medical Drug Copay:</b> {{ patientviewData.copaY_BRAND_PERCENT }} %</div>
            <div class="mt-1"><b> Office Visit Copay:</b></div>
            <div class="mt-1"><b>Medical Drug Coinsurance:</b> {{ patientviewData.percenT_COVERAGE }}%</div>
          </div>
        </div>
        <div class="shadow p-2">
          <h3 class="no-wrap">Insurance Restrictions</h3>
          <div class="font-14px mt-4">
            <div><b>PA Required: </b> {{ patientviewData.pA_REQUIERED ? 'Yes' : 'No' }}</div>
            <div class="mt-1"><b>Policy Effective Date: </b> {{ getFormattedDate(patientviewData.insuR_EFFECTIVE_DATE) }}</div>
            <div class="mt-1"><b>Treating Provider Network Status:</b>In-network</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import SPCoreMenu from '../../components/spcore/menu/SPCoreMenu.vue';
import axios from '../../axios';
import patientActiveImage from '../../assets/images/Patient@2x.png'

import moment from 'moment';
export default {
  title: 'Patient',
  components: { SPCoreMenu },
  data() {
    return {
      isFiltering: {},
      patientId: 0,
      patientviewData: {},
      riskStatus: '',
      deductPercent: 0,
      outPercent: 0,
      patientActiveImage,
    }
  },
  methods: {
    loadPatientView() {

      this.$set(this.isFiltering, 'filterList', true);
      axios.get(`/SPCore/PatientList/${this.$route.params.id}/Data`)
        .then((response) => {
          this.isFiltering.filterList = false;
          this.patientviewData = response.data;
          this.riskStatus = response.data.risk;
          if (response.data.deductiblE_LEFT > 0 && response.data.deductiblE_AMT > 0) {
            this.deductPercent = parseInt(Math.round((response.data.deductiblE_LEFT / response.data.deductiblE_AMT) * 100));
          }
          if (response.data.ooP_LEFT > 0 && response.data.ooP_AMT) {
            this.outPercent = parseInt(Math.round((response.data.ooP_LEFT / response.data.ooP_AMT) * 100));
          }


        }).catch((error) => {
          if (!axios.isCancel(error)) {
            this.isFiltering.filterList = false;
            console.log(error);

          }
        });
    },
    getFormattedDate(date) {
      return moment(date).format("MM-DD-YYYY")
    },

  },
  computed: {
    isFilteringAny() {
      return Object.keys(this.isFiltering).find(key => this.isFiltering[key]);
    },
    colorStyle() {

      var colors = {
        LOW: 'green',
        MEDIUM: 'yellow',
        HIGH: 'red'
      };
      return { backgroundColor: colors[this.riskStatus] };
    },

  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisSPCorePatient'] = this;
    this.loadPatientView();

  }
}
</script>